import { Chart, tokens } from "@sunrun/experience-ui-components";
import { ChartProps } from "@sunrun/experience-ui-components/lib/components/Chart/Chart";

const SolarProductionGraph = ({
  data,
  isFlexMonthly,
}: {
  data: Partial<ChartProps>;
  isFlexMonthly: boolean;
}) => {
  return (
    <Chart
      xLabel="month"
      xLabelFormat={(label) => label?.toString().charAt(0)}
      showXGrid
      howManyXAxis={4}
      domainPadding={30}
      barRatio={0.5}
      toolTipAlignment={-125}
      toolTipFontSize={18}
      useToolTip={true}
      excessGraph={true}
      lineStrokeWidth={4}
      legendOnTop={false}
      addedBottomPadding={20}
      legendOffsetY={-20}
      mobileLegend={{
        itemsPerRow: 1,
        padding: isFlexMonthly ? 100 : 80,
        offsetY: isFlexMonthly ? -100 : -80,
      }}
      toolTipLabelProps={{
        dx: -125,
        style: [
          {
            fontWeight: "500",
            fontFamily: "Roobert, sans-serif",
            fill: tokens.HEROBLUE_20,
            fontSize: "20px",
          },
          ...new Array(4).fill({
            fontWeight: "300",
            fontFamily: "Roobert, sans-serif",
            fill: tokens.HEROBLUE_20,
            fontSize: "16px",
          }),
        ],
      }}
      toolTipPointerLength={20}
      toolTipPointerWidth={40}
      toolTipProps={{
        constrainToVisibleArea: false,
        flyoutStyle: {
          strokeWidth: 30,
          stroke: tokens.TINTS_INFO_80,
          fill: tokens.TINTS_INFO_80,
          minWidth: 300,
        },
      }}
      {...data}
    />
  );
};

export { SolarProductionGraph };
